module.exports = __webpack_public_path__ + "media/app/assets/specializations/warlock/affliction-6f64b2d3a2a20842fb0b261951b84079.png";